import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { LabelQueryKeys } from '../config/queryKeys';
import { BFFClient } from '../lib/BFFClient';
import { getRequestHeaders } from '../lib/headers';
import {
  type LabelListResponse,
  LabelListResponseSchema,
} from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';
import type { PaginationVariables } from '../types/paginationVariables';
import type { SearchVariables } from '../types/searchVariables';

export interface LabelListQueryVariables
  extends PaginationVariables,
    SearchVariables {
  userId?: string;
  labelIds?: string;
  labelGroupIds?: string;
  parentIds?: string;
  labelType?: string;
  sortBy?: string;
  orderDir?: string;
  orderBy?: string;
  canCreateUsers?: boolean;
  canEditUsers?: boolean;
}

export function useLabelList<TData = LabelListResponse>(
  variables: LabelListQueryVariables,
  options?: PresetUseQueryOptions<LabelListResponse, TData>,
) {
  const session = useWmgSession();

  const { data, ...query } = useQuery({
    queryKey: LabelQueryKeys.list(variables),
    queryFn: async () => {
      const responseData = await BFFClient.get('labels', {
        headers: getRequestHeaders(session.token),
        searchParams: { ...variables },
      }).json();

      return LabelListResponseSchema.parse(responseData);
    },
    placeholderData: keepPreviousData,
    ...options,
  });

  return { labelList: data, ...query };
}
